
function initNavigator() {
	const navigator = document.querySelector('.ivy-navigator');

	navigator.onmouseover = () => {
		navigator.classList.remove('closed');
		navigator.classList.add('open');
		setTimeout(() => {
			navigator.classList.add('closed');
		}, 15000);
	};
}

document.addEventListener('DOMContentLoaded', initNavigator);
